// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"820":"03f399e3","1358":"03f399e3","1890":"03f399e3","2639":"03f399e3","4000":"03f399e3","4175":"03f399e3","8984":"03f399e3"}[chunkId] + ".chunk.css";
};